import React from 'react';
import Layout from '../components/layout/Layout';
import ReportStaticTextsList from '../components/reportstatictexts/ReportStaticTextsList';
import ReportStaticTextsModal from '../components/reportstatictexts/ReportStaticTextsModal';
import { ReportStaticTextsProvider } from '../contexts/ReportStaticTextsContext';

const ReportStaticTextsPage = () => {
  return (
    <Layout>
      <ReportStaticTextsProvider>
        <ReportStaticTextsList />
        
        {/* Modal for creating/editing report static texts */}
        <ReportStaticTextsModal />
      </ReportStaticTextsProvider>
    </Layout>
  );
};

export default ReportStaticTextsPage;
